import { render, staticRenderFns } from "./DiscountCodeAdditionalOptionsModal.vue?vue&type=template&id=2579c22c&scoped=true"
import script from "./DiscountCodeAdditionalOptionsModal.vue?vue&type=script&lang=js"
export * from "./DiscountCodeAdditionalOptionsModal.vue?vue&type=script&lang=js"
import style0 from "./DiscountCodeAdditionalOptionsModal.vue?vue&type=style&index=0&id=2579c22c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2579c22c",
  null
  
)

export default component.exports